module.exports = __webpack_public_path__ + "assets/media/drift-logo-with-name.cc8afc22.svg";